import { useEffect, useState } from "react"

//constants
import { ENDPOINTS } from "constants/endpoints"

//hooks
import useFetch from "hooks/useFetch"

function useFetchTasksTransactions(categoryId, userId, startDate, endDate) {
    const { fetch, loading } = useFetch()
    const [transactions, setTransactions] = useState({})

    useEffect(() => {
        _fetchData()
    }, [startDate, categoryId, userId,endDate])

    function _fetchData() {
        const params = `?task_type=${categoryId}&worker=${userId}&start_date=${startDate}&end_date=${endDate || 0}`

        fetch({ endpoint: `task-reference${params}`, method: 'get' })
            .then(res => {
                setTransactions(res.data)
            })
    }

    function getTransactions() {
        return transactions
    }

    function refetchData() {
        _fetchData()
    }

    return {
        getTransactions,
        loading,
        refetchData,
    }
}

export default useFetchTasksTransactions